import { DirectionType } from "@american-heart/aui";
import React, { useEffect, useRef } from "react";

interface AuiFileUploadProps {
  allowedfiletypes: string;
  maxuploadsize: number;
  iseditable: boolean;
  fileuploadlabel: boolean;
  auifiluploaddirection?: DirectionType;
  auifiluploaderrorstate: boolean;
  auifiluploadrequired: boolean;
  auifiluploadrequiredmessage: string;
  auifileuploaderrormessage: string;
  onChange: (files: FileList | null) => void;
  fileuploadlabeltext?: string
}

const AuiFileUpload: React.FC<AuiFileUploadProps> = ({
  allowedfiletypes,
  maxuploadsize,
  iseditable,
  fileuploadlabel,
  auifiluploaddirection,
  auifiluploaderrorstate,
  auifiluploadrequired,
  auifiluploadrequiredmessage,
  auifileuploaderrormessage,
  onChange,
  fileuploadlabeltext
}) => {
  const fileUploadRef = useRef<HTMLAuiFileuploadElement>(null);

  useEffect(() => {
    const fileUploadElement = fileUploadRef.current;

    const handleFileChange = (event: any) => {
      if (event.detail.file) {
        const fileList = new DataTransfer();
        fileList.items.add(event.detail.file);
        onChange(fileList.files);
      } else {
        onChange(null);
      }
    };

    fileUploadElement?.addEventListener("auiFileChange", handleFileChange);
    const shadowRoot = fileUploadElement?.shadowRoot;
    if (shadowRoot) {      
      const style = document.createElement("style");      
      style.textContent = `
        .progressbar-text {
          text-wrap: nowrap;
        }
      `;
      shadowRoot.appendChild(style);
    }  

    return () => {
      fileUploadElement?.removeEventListener("auiFileChange", handleFileChange);
    };
  }, [onChange]);

  return (
    <aui-fileupload
      ref={fileUploadRef}
      allowedfiletypes={allowedfiletypes}
      maxuploadsize={maxuploadsize}
      iseditable={iseditable}
      fileuploadlabel={fileuploadlabel}
      auifiluploaddirection={auifiluploaddirection}
      auifiluploaderrorstate={auifiluploaderrorstate}
      auifiluploadrequired={auifiluploadrequired}
      auifiluploadrequiredmessage={auifiluploadrequiredmessage}
      auifileuploaderrormessage={auifileuploaderrormessage}
      fileuploadlabeltext={fileuploadlabeltext}
    ></aui-fileupload>
  );
};

export default AuiFileUpload;
